import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo.png';
import './Navbar.css';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isEnglish = location.pathname.startsWith('/en');
  
  const getPath = (path) => {
    if (isEnglish) {
      if (path === '/') return '/en';
      const pathMap = {
        '/hakkinda': '/en/about',
        '/projeler': '/en/projects',
        '/iletisim': '/en/contact',
        '/destek': '/en/support',
        '/yazilim-hizmetleri': '/en/software-services',
        '/yazilim-hesaplayici': '/en/software-calculator',
        '/cerez-politikasi': '/en/cookie-policy'
      };
      return pathMap[path] || '/en' + path;
    }
    return path;
  };
  
  const getMenuText = (text) => {
    if (isEnglish) {
      const translations = {
        'ANA SAYFA': 'HOME',
        'HAKKINDA': 'ABOUT',
        'PROJELER': 'PROJECTS',
        'İLETİŞİM': 'CONTACT',
        'DESTEK': 'SUPPORT',
        'YAZILIM': 'SOFTWARE',
        'HESAPLAYICI': 'CALCULATOR'
      };
      return translations[text] || text;
    }
    return text;
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const menuItems = [
    { path: "/", text: "ANA SAYFA" },
    { path: "/hakkinda", text: "HAKKINDA" },
    { path: "/projeler", text: "PROJELER" },
    { path: "/yazilim-hizmetleri", text: "YAZILIM" },
    { path: "/yazilim-hesaplayici", text: "HESAPLAYICI" },
    { path: "/destek", text: "DESTEK" },
    { path: "/iletisim", text: "İLETİŞİM" }
  ];

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to={isEnglish ? '/en' : '/'} className="navbar-logo">
          <img src={logo} alt="ProgenX Logo" />
        </Link>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
        </div>
        
        <ul className={menuOpen ? 'nav-menu active' : 'nav-menu'}>
          {menuItems.map((item, index) => (
            <li className="nav-item" style={{"--item-index": index}} key={index}>
              <Link to={getPath(item.path)} className="nav-link" onClick={() => setMenuOpen(false)}>
                {getMenuText(item.text)}
              </Link>
            </li>
          ))}
          <li className="nav-item language-switcher-item" style={{"--item-index": menuItems.length}}>
            <LanguageSwitcher onLanguageChange={() => setMenuOpen(false)} />
          </li>
        </ul>
        
        <div className="navbar-desktop-language-switcher">
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
